package one.healthium.reminders.domain

data class ReminderNotificationModel(
    val title: String,
    val description: String,
)
